export const JurisdictionIdFieldNames = {
  CaNSC: 'caNSC',
  AbMVIDNumber: 'abMVIDNumber',
  BcCustomerNumber: 'bcCustomerNumber',
  BcFINNumber: 'bcFINNumber',
  QcNEQNumber: 'qcNEQNumber',
  QcNIRNumber: 'qcNIRNumber',
  OnCVORNumber: 'onCVORNumber',
  OnPRIOAccountNumber: 'onPRIOAccountNumber',
  NlMasterNumber: 'nlMasterNumber',
  UsICC: 'usICC',
  UsIFTA: 'usIFTA',
  UsIRP: 'usIRP',
  UsDotNumber: 'usDotNumber',
  FederalIdNumber: 'federalIdNumber',
  LaNumber: 'laNumber',
  KentuckyNumber: 'kentuckyNumber',
  MontanaNumber: 'montanaNumber',
  OregonFileNumber: 'oregonFileNumber',
  TennesseeNumber: 'tennesseeNumber',
  TexasNumber: 'texasNumber',
} as const;

export type JurisdictionIdFields = {
  [JurisdictionIdFieldNames.CaNSC]?: string;
  [JurisdictionIdFieldNames.AbMVIDNumber]?: string;
  [JurisdictionIdFieldNames.BcCustomerNumber]?: string;
  [JurisdictionIdFieldNames.BcFINNumber]?: string;
  [JurisdictionIdFieldNames.QcNEQNumber]?: string;
  [JurisdictionIdFieldNames.QcNIRNumber]?: string;
  [JurisdictionIdFieldNames.OnCVORNumber]?: string;
  [JurisdictionIdFieldNames.OnPRIOAccountNumber]?: string;
  [JurisdictionIdFieldNames.NlMasterNumber]?: string;
  [JurisdictionIdFieldNames.UsICC]?: string;
  [JurisdictionIdFieldNames.UsIFTA]?: string;
  [JurisdictionIdFieldNames.UsIRP]?: string;
  [JurisdictionIdFieldNames.UsDotNumber]?: string;
  [JurisdictionIdFieldNames.FederalIdNumber]?: string;
  [JurisdictionIdFieldNames.LaNumber]?: string;
  [JurisdictionIdFieldNames.KentuckyNumber]?: string;
  [JurisdictionIdFieldNames.MontanaNumber]?: string;
  [JurisdictionIdFieldNames.OregonFileNumber]?: string;
  [JurisdictionIdFieldNames.TennesseeNumber]?: string;
  [JurisdictionIdFieldNames.TexasNumber]?: string;
};
